<top-banner variant="small"></top-banner>
<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">

          <card-section-header title="Site Induction Report" icon="fas fa-list"></card-section-header>
          <div class="row">
            <div class="col-md-12">
              <p>Report showing site induction status for workers across for all sites</p>
              <button type="button" (click)="generateInductionReport()" class="btn btn-success btn-round">
                <strong>Generate Report</strong>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
